<template>
    <div class="body-results">
        <div>
            <h2 class="title-body-results">Votre
                <span v-if="who === 'Un touriste'">
                    voyage
                </span>
                <span v-if="who === 'Un évènement'">
                   évènement
                </span>
                <span v-if="who === 'Une organisation'">
                    organisation
                </span>
                <span v-if="who === 'Un citoyen'">
                    ménage
                </span> émet environ
            </h2>
            <div class="result-container container" :class="{ 'justify-center': (result * price).toFixed(2) > 8000 }">
                <div class="text-number-emission"><span class="number-emission">{{ result }}</span> tonnes de
                    CO<sub><small>2</small></sub> eq.</div>
                <div class="price-emission" v-if="(result * price).toFixed(2) < 8000">{{ (result * price).toFixed(2) }}$</div>
            </div>
            <div class="mt-50px d-flex justify-center" v-if="(result * price).toFixed(2) < 8000">
                <a class="btn-primary"
                    :href="'https://buy.stripe.com/fZecPZeFq56K1VedQQ?__prefilled_amount=' + (result * price).toFixed(2) * 100"
                    target="_blank">Faire un don pour compenser mes GES</a>
            </div>
            <div v-else class="container-70 mt-50px">
                <div v-if="loading" class="d-flex jusitfy-center">
                    <div class="loader"></div>
                </div>
                <div v-else>
                    <div class="row">
                        <div class="paragraph">
                            Nous offrons un taux adapté aux grands volumes d'achats de crédits carbone.
                            Merci de remplir le formulaire afin que nous puissions vous accompagner pour la suite.
                        </div>
                    </div>
                    <div class="row mt-20px">
                        <div class="col-50 p-10px box-sizing">
                            <input class="calculator-input-square w-100" placeholder="Nom" v-model="nom" />
                        </div>
                        <div class="col-50 p-10px box-sizing">
                            <input class="calculator-input-square w-100" placeholder="Organisation"
                                v-model="organisation" />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-50 p-10px box-sizing">
                            <input class="calculator-input-square w-100" placeholder="Courriel" v-model="courriel" />
                        </div>
                        <div class="col-50 p-10px box-sizing">
                            <input class="calculator-input-square w-100" placeholder="Téléphone" v-model="telephone" />
                        </div>
                    </div>
                    <div class="row justify-center">
                        <button class="btn-primary mt-20px" @click="demanderUneCompensation()">Envoyer le formulaire
                            pour compenser mes GES</button>
                    </div>
                </div>
                <div v-if="successSending">
                    <div class="success mt-20px">Votre demande de compensation a bien été envoyé. Nous communiquerons
                        avec vous dans les plus brefs délais.</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from "axios";
export default {
    data() {
        return {
            price:20,
            nom: '',
            courriel: '',
            organisation: '',
            telephone: '',
            loading: false,
            successSending: false,
          
        }
    },
    props: {
        result: Number,
        who:String
    },
    methods: {
        demanderUneCompensation() {
            this.loading = true;
            let body = {
                nom: this.nom,
                courriel: this.courriel,
                organisation: this.courriel,
                telephone: this.telephone,
                ges: this.result,
                montant: (this.result * this.price).toFixed(2)
            }
            axios.post('https://3rdurable.org/wp-json/reponses-ges/v1/demande-compensation/', body).then((response) => {
                if (response.status === 200) {
                    this.successSending = true
                }
            }).catch(err => {
                console.error(err)
            }).finally(() => {
                this.loading = false;
            });
        }
    }
}
</script>
<style>
.body-results {
    width: 60%;
    display: flex;
    justify-content: center;
}
.title-body-results {
    color: var(--text-color);
    text-align: center;
    font-family: var(--font);
    font-size: 42px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
}
.result-container {
    display: flex;
    width: 100%;
}

.number-emission {
    color: var(--text-color);
    text-align: center;
    font-family: var(--font);
    font-size: 42px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
}

.justify-center {
    justify-content: center;
}

.text-number-emission {
    color: var(--text-color);
    font-family: var(--font);
    font-size: 32px;
    font-style: normal;
    font-weight: 600;
    line-height: 33.2px;
    border-radius: 0px 0px 50px 0px;
    border: 2px solid var(--text-color);
    background: #CCEAED;
    padding: 12px 44px 12px 24px;
    z-index: 1;
    margin-left: 42px;
}

.price-emission {
    border-radius: 0px 0px 50px 0px;
    background: var(--Secondary-Eau, #00B5C6);
    color: var(--Secondary-blanc, #FFF);
    text-align: center;
    font-family: var(--font);
    font-size: 42px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    padding: 12px 44px 12px 68px;
    transform: translateX(-42px);

}

.box-sizing {
    box-sizing: border-box;
}

/* HTML: <div class="loader"></div> */
.loader {
    width: 50px;
    padding: 8px;
    aspect-ratio: 1;
    border-radius: 50%;
    background: #25b09b;
    --_m:
        conic-gradient(#0000 10%, #000),
        linear-gradient(#000 0 0) content-box;
    -webkit-mask: var(--_m);
    mask: var(--_m);
    -webkit-mask-composite: source-out;
    mask-composite: subtract;
    animation: l3 1s infinite linear;
}

@keyframes l3 {
    to {
        transform: rotate(1turn)
    }
}

@media screen and (max-width: 1520px) {
    .body-results {
        width: 100%;
    }
    .title-body-results{
        font-size: 35px;
    }
    .text-number-emission{
        font-size: 27px;
    }
    .number-emission {
        font-size: 27px;
    }
    .price-emission {
        font-size: 27px;
    }

}
@media (max-width: 992px) {
    .title-body-results {
        font-size: 32px;
    }

    .number-emission {
        font-size: 25px;
    }

    .price-emission {
        font-size: 25px;
    }

    .text-number-emission {
        font-size: 20px;
    }
}

@media (max-width: 768px) {
    .title-body-results {
        font-size: 30px;
    }
    .number-emission {
        font-size: 20px;
    }

    .price-emission {
        font-size: 20px;
    }

    .text-number-emission {
        font-size: 18px;
    }
}

@media (max-width: 600px) {
    .title-body-results {
        font-size: 28px;
    }

    .price-emission {
        width: 100%;
        margin-left: 42px;
        margin-right: 42px;
        transform: translateX(0);
    }

    .text-number-emission {
        width: 100%;
        margin-right: 42px;
        border-radius: 0px 0px 0px 0px;
        text-align: center;
    }

    .result-container {
        flex-wrap: wrap;
    }

}
</style>